/**
 * RBC Native Bridge Configuration
 *
 * Adjust these settings based on RBC's requirements:
 * - Enable/disable native bridge posting
 * - Configure event type mappings
 * - Set the analytics framework version
 */

/**
 * Feature flag to enable/disable native bridge posting
 * Set to false if you want to disable native bridge integration temporarily
 */
export const ENABLE_NATIVE_BRIDGE = true;

/**
 * RBC Analytics Framework version
 * Update this when RBC specifies a different version
 */
export const RBC_ANALYTICS_VERSION = "1.2";

/**
 * Event type mapping for RBC native bridge
 * Maps event patterns to RBC's expected types:
 * - Click/tap events → type: "click", name: "tap"
 * - Page/screen view events → type: "view", name: "screen_view"
 */
export const RBC_EVENT_TYPE_MAPPING = {
  CLICK: "click",
  VIEW: "view",
  TAP: "tap",
  SCREEN_VIEW: "screen_view",
} as const;
